import request from './request'

// 认证相关API
export const authAPI = {
  // 用户登录
  login(data) {
    return request({
      url: '/auth/login',
      method: 'post',
      data
    })
  },
  
  // 用户注册
  register(data) {
    return request({
      url: '/auth/register',
      method: 'post',
      data
    })
  },
  
  // 发送短信验证码
  sendSmsCode(data) {
    return request({
      url: '/auth/send-sms',
      method: 'post',
      data
    })
  },
  
  // 短信验证码登录
  smsLogin(data) {
    const requestData = {
      phone: data.phone,
      sms_code: data.smsCode,  // 转换为后端期望的字段名
      remember: data.remember || false
    }
    // 如果提供了user_id（多账户选择后），添加到请求中
    if (data.user_id) {
      requestData.user_id = data.user_id
    }
    return request({
      url: '/auth/sms-login',
      method: 'post',
      data: requestData
    })
  },
  
  // 获取用户信息
  getUserInfo() {
    return request({
      url: '/auth/user',
      method: 'get'
    })
  },
  
  // 退出登录
  logout() {
    return request({
      url: '/auth/logout',
      method: 'post'
    })
  },
  
  // 生成微信登录二维码
  generateWechatQRCode() {
    return request({
      url: '/auth/qrcode-login/generate',
      method: 'post'
    })
  },
  
  // 检查微信登录状态
  checkWechatLoginStatus(token) {
    return request({
      url: `/auth/qrcode-login/status/${token}`,
      method: 'get'
    })
  }
}

// 产品相关API
// 产品建议相关API
export const productSuggestionAPI = {
  // 创建产品建议
  createSuggestion(data) {
    return request({
      url: '/product-suggestions/',
      method: 'post',
      data
    })
  }
}

export const productAPI = {
  // 获取产品列表
  getProducts(params) {
    return request({
      url: '/products',
      method: 'get',
      params
    })
  },
  
  // 获取产品详情
  getProductDetail(id, params = {}) {
    console.log('🔍 PC端API.getProductDetail 调试信息:')
    console.log('  - 产品ID:', id)
    console.log('  - 请求URL:', `/products/${id}`)
    console.log('  - 查询参数:', params)
    
    return request({
      url: `/products/${id}`,
      method: 'get',
      params
    }).then(response => {
      console.log('✅ PC端API.getProductDetail 成功:', response)
      return response
    }).catch(error => {
      console.error('❌ PC端API.getProductDetail 失败:', error)
      throw error
    })
  },

  // 获取产品相关推荐（路径勿带 /api，baseURL 已为 /api）
  getProductRecommendations(productId) {
    return request({
      url: `/products/${productId}/recommendations`,
      method: 'get'
    })
  },

  // 获取产品专家评价列表
  getProductReviews(productId, params = {}) {
    return request({
      url: `/products/${productId}/reviews`,
      method: 'get',
      params
    })
  },
  
  // 搜索产品
  searchProducts(params) {
    return request({
      url: '/products/search',
      method: 'get',
      params
    })
  },
  
  // 获取产品分类
  async getCategories() {
    const res = await request({
      url: '/products/categories',
      method: 'get'
    })
    // 适配新的items格式
    return {
      ...res,
      data: res.items || res.data || res
    }
  },

  // 发布产品
  publishProduct(data) {
    return request({
      url: '/products',
      method: 'post',
      data
    })
  },
  // 获取我的产品
  async getMyProducts() {
    const res = await request({
      url: '/products/my',
      method: 'get'
    })
    return res
  },
  // 发布产品
  publishMyProduct(data) {
    return request({
      url: '/products/my/publish',
      method: 'post',
      data
    })
  },
  // 获取产品详情
  getMyProductDetail(id, params = {}) {
    return request({
      url: `/products/my/${id}`,
      method: 'get',
      params
    })
  },
  // 获取产品编辑状态
  getProductEditStatus(id) {
    return request({
      url: `/products/my/${id}/edit-status`,
      method: 'get'
    })
  },
  // 编辑产品
  editProduct(id, data) {
    return request({
      url: `/products/my/${id}`,
      method: 'put',
      data
    })
  },
  // 更新产品库存
  async updateProductInventory(id, data) {
    try {
      return await request({
        url: `/products/my/${id}/inventory`,
        method: 'patch',
        data
      })
    } catch (error) {
      const status = error?.response?.status
      if (status === 404 || status === 405 || status === 422) {
        return await request({
          url: `/products/my/${id}/inventory`,
          method: 'put',
          data
        })
      }
      throw error
    }
  },
  // 删除产品
  deleteProduct(id) {
    return request({
      url: `/products/my/${id}`,
      method: 'delete'
    })
  },
  // 提炼并保存产品要点（生成海报时调用）
  extractHighlights(productId) {
    return request({
      url: `/products/${productId}/extract-highlights`,
      method: 'post'
    })
  },
  // 获取产品要点列表
  getHighlights(productId) {
    return request({
      url: `/products/${productId}/highlights`,
      method: 'get'
    })
  }
}

// 企业相关API
// 上传相关API
export const uploadAPI = {
  // 代理获取图片（返回base64，避免Canvas跨域污染）
  proxyImage(url) {
    return request({
      url: '/upload/proxy-image',
      method: 'get',
      params: { url }
    })
  }
}

export const enterpriseAPI = {
  // 获取企业列表
  getEnterprises(params) {
    return request({
      url: '/enterprises',
      method: 'get',
      params
    })
  },
  
  // 获取企业详情
  getEnterpriseDetail(id) {
    return request({
      url: `/enterprises/${id}`,
      method: 'get'
    })
  },
  getStats() {
    return request({
      url: '/enterprises/stats',
      method: 'get'
    })
  },
  
  // 获取我的企业信息
  getMyEnterprise() {
    return request({
      url: '/enterprises/my',
      method: 'get'
    })
  },

  // 将当前用户关联的企业设为公益企业
  setPublicWelfare() {
    return request({
      url: '/enterprises/me/public-welfare',
      method: 'patch'
    })
  }
}

// 需求相关API
export const demandAPI = {
  // 获取需求列表
  getDemands(params) {
    return request({
      url: '/demands',
      method: 'get',
      params
    })
  },
  
  // 获取需求详情
  getDemandDetail(id) {
    return request({
      url: `/demands/${id}`,
      method: 'get'
    })
  },
  
  // 获取需求匹配结果
  getDemandMatches(id, forceRefresh = false) {
    return request({
      url: `/demands/${id}/matches`,
      method: 'get',
      params: {
        force_refresh: forceRefresh
      }
    })
  },
  
  // 获取需求详情
  getMyDemandDetail(id) {
    return request({
      url: `/demands/my/${id}`,
      method: 'get'
    })
  },
  
  // 获取需求编辑状态
  getDemandEditStatus(id) {
    return request({
      url: `/demands/my/${id}/edit-status`,
      method: 'get'
    })
  },
  // 发布需求
  publishMyDemand(data) {
    return request({
      url: '/demands/my',
      method: 'post',
      data
    })
  },
  // 删除需求
  deleteMyDemand(id) {
    return request({
      url: `/demands/my/${id}`,
      method: 'delete'
    })
  },
  // 更新需求
  updateMyDemand(id, data) {
    return request({
      url: `/demands/my/${id}`,
      method: 'patch',
      data
    })
  },
  // 完成需求
  completeDemand(id) {
    return request({
      url: `/demands/my/${id}/complete`,
      method: 'post'
    })
  }
}

// 智库相关API
export const thinktankAPI = {
  // 获取专家列表
  getExperts(params = {}) {
    // 添加时间戳参数避免缓存
    const paramsWithTimestamp = {
      ...params,
      _t: Date.now() // 添加时间戳防止缓存
    }
    return request({
      url: '/thinktank/experts',
      method: 'get',
      params: paramsWithTimestamp
    })
  },
  
  // 获取专家详情
  getExpertDetail(id) {
    return request({
      url: `/thinktank/experts/${id}`,
      method: 'get'
    })
  },
  
  // 增加专家浏览量
  incrementExpertView(expertId) {
    return request({
      url: `/thinktank/experts/${expertId}/increment-view`,
      method: 'post'
    })
  },
  
  // 增加专家咨询次数
  incrementExpertConsultation(expertId) {
    return request({
      url: `/thinktank/experts/${expertId}/increment-consultation`,
      method: 'post'
    })
  },
  
  // 获取文章列表
  getArticles(params) {
    return request({
      url: '/thinktank/articles',
      method: 'get',
      params
    })
  },
  
  // 根据专家行业标签获取匹配的产品
  getMatchedProducts(expertId, limit = 6) {
    return request({
      url: `/experts/${expertId}/matched-products`,
      method: 'get',
      params: { limit }
    })
  },
  
  // 获取文章详情
  getArticleDetail(id) {
    return request({
      url: `/thinktank/articles/${id}`,
      method: 'get'
    })
  }
}

// 安全课堂相关API
export const classroomAPI = {
  // 获取课程列表
  getCourses(params) {
    return request({
      url: '/classroom/courses',
      method: 'get',
      params
    })
  },
  
  // 获取课程详情
  getCourseDetail(id) {
    return request({
      url: `/classroom/courses/${id}`,
      method: 'get'
    })
  },
  
  // 获取视频列表
  getVideos(params) {
    return request({
      url: '/classroom/videos',
      method: 'get',
      params
    })
  },
  getCourseCategories() {
    return request({
      url: '/classroom/categories',
      method: 'get'
    })
  },
} 

export const getUserInfo = () => request.get('/auth/user')
export const getMyDemands = () => request.get('/demands/my')
export const publishDemand = (data) => request.post('/demands', data)

// 安全课堂相关API
export const aqClassroomAPI = {
  // 课程分类
  getCategories(params) {
    return request({
      url: '/aq-classroom/categories',
      method: 'get',
      params
    })
  },
  createCategory(data) {
    return request({
      url: '/aq-classroom/categories',
      method: 'post',
      data
    })
  },
  updateCategory(id, data) {
    return request({
      url: `/aq-classroom/categories/${id}`,
      method: 'put',
      data
    })
  },
  deleteCategory(id) {
    return request({
      url: `/aq-classroom/categories/${id}`,
      method: 'delete'
    })
  },
  
  // 课程内容
  getContents(params) {
    return request({
      url: '/aq-classroom/contents',
      method: 'get',
      params
    })
  },
  createContent(data) {
    return request({
      url: '/aq-classroom/contents',
      method: 'post',
      data
    })
  },
  updateContent(id, data) {
    return request({
      url: `/aq-classroom/contents/${id}`,
      method: 'put',
      data
    })
  },
  deleteContent(id) {
    return request({
      url: `/aq-classroom/contents/${id}`,
      method: 'delete'
    })
  },
  
  // 文件上传
  uploadFile(formData) {
    return request({
      // 线上Nginx需要以 /api 开头，否则会404
      url: '/api/aq-classroom/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  getFiles(params) {
    return request({
      url: '/aq-classroom/files',
      method: 'get',
      params
    })
  },
  
  // 我的课程
  addToMyCourses(contentId) {
    return request({
      url: '/aq-classroom/my-courses/add',
      method: 'post',
      data: { content_id: contentId }
    })
  },
  removeFromMyCourses(contentId) {
    return request({
      url: `/aq-classroom/my-courses/${contentId}`,
      method: 'delete'
    })
  },
  getAvailableCourses(params) {
    return request({
      url: '/aq-classroom/available-courses',
      method: 'get',
      params
    })
  },
  
  // PC端用户基于公共课程创建我的课程
  createMyCourseFromPublic(data) {
    return request({
      url: '/aq-classroom/my-courses/create-from-public',
      method: 'post',
      data
    })
  },
  
  // 用户学习进度
  getUserProgress(params) {
    return request({
      url: '/aq-classroom/user-progress',
      method: 'get',
      params
    })
  },
  updateUserProgress(data) {
    return request({
      url: '/aq-classroom/user-progress',
      method: 'post',
      data
    })
  },
  getUserStats() {
    return request({
      url: '/aq-classroom/user-stats',
      method: 'get'
    })
  }
} 

export const eventAPI = {
  getEvents(params) {
    return request({
      url: '/events',
      method: 'get',
      params
    })
  },
  getEventDetail(id) {
    return request({
      url: `/events/${id}`,
      method: 'get'
    })
  },
  likeEvent(id) {
    return request({
      url: `/events/${id}/like`,
      method: 'post'
    })
  },
  unlikeEvent(id) {
    return request({
      url: `/events/${id}/like`,
      method: 'delete'
    })
  },
  checkLikeStatus(id) {
    return request({
      url: `/events/${id}/like/status`,
      method: 'get'
    })
  }
}

// 快讯相关API（用户端）
export const newsAPI = {
  // 获取我的快讯
  getMyNews() {
    return request({
      url: '/events/my',
      method: 'get'
    })
  },
  // 发布快讯
  publishNews(data) {
    return request({
      url: '/events/my/publish',
      method: 'post',
      data
    })
  },
  // 获取我的快讯详情
  getMyNewsDetail(id) {
    return request({
      url: `/events/my/${id}`,
      method: 'get'
    })
  },
  // 获取快讯编辑状态
  getNewsEditStatus(id) {
    return request({
      url: `/events/my/${id}/edit-status`,
      method: 'get'
    })
  },
  // 更新快讯
  updateNews(id, data) {
    return request({
      url: `/events/my/${id}`,
      method: 'put',
      data
    })
  },
  // 删除快讯
  deleteNews(id) {
    return request({
      url: `/events/my/${id}`,
      method: 'delete'
    })
  }
} 

export const caseAPI = {
  getCases(params) {
    return request({
      url: '/cases',
      method: 'get',
      params
    })
  },
  getCaseOptions() {
    return request({
      url: '/cases/filters',
      method: 'get'
    })
  },
  // 获取企业案例
  getEnterpriseCases(enterpriseId, params = {}) {
    return request({
      url: '/cases',
      method: 'get',
      params: { enterprise_id: enterpriseId, ...params }
    })
  },
  getCaseDetail(id) {
    return request({
      url: `/cases/${id}`,
      method: 'get'
    })
  },
  
  // 获取我的案例
  getMyCases() {
    return request({
      url: '/cases/my',
      method: 'get'
    })
  },
  
  // 创建案例
  createCase(data) {
    return request({
      url: '/cases/my',
      method: 'post',
      data
    })
  },
  
  // 更新案例
  updateCase(id, data) {
    return request({
      url: `/cases/my/${id}`,
      method: 'put',
      data
    })
  },
  
  // 获取案例编辑状态
  getCaseEditStatus(id) {
    return request({
      url: `/cases/my/${id}/edit-status`,
      method: 'get'
    })
  },
  
  // 删除案例
  deleteCase(id) {
    return request({
      url: `/cases/my/${id}`,
      method: 'delete'
    })
  }
} 

export const policyAPI = {
  getPolicies(params) {
    return request({
      url: '/policy-management/public/details',
      method: 'get',
      params
    })
  },
  getPolicyDetail(id) {
    return request({
      url: `/policy-management/public/details/${id}`,
      method: 'get'
    })
  },
  getPolicyCategories(params) {
    return request({
      url: '/policy-management/public/categories',
      method: 'get',
      params
    })
  },
  getEmergencyContacts() {
    return request({
      url: '/emergency-contacts',
      method: 'get'
    })
  }
} 

// 服务相关API
export const serviceAPI = {
  // 获取服务列表
  getServices(params) {
    return request({
      url: '/services',
      method: 'get',
      params
    })
  },
  
  // 获取服务详情
  getServiceDetail(id) {
    return request({
      url: `/services/${id}`,
      method: 'get'
    })
  },
  
  // 获取服务统计
  getStats() {
    return request({
      url: '/services/stats',
      method: 'get'
    })
  },
  
  // 发布服务
  publishService(data) {
    return request({
      url: '/services',
      method: 'post',
      data
    })
  },
  
  // 更新服务
  updateService(id, data) {
    return request({
      url: `/services/${id}`,
      method: 'patch',
      data
    })
  },
  
  // 删除服务
  deleteService(id) {
    return request({
      url: `/services/${id}`,
      method: 'delete'
    })
  },
  
  // 获取我的服务
  getMyServices() {
    return request({
      url: '/services/my',
      method: 'get'
    })
  }
} 

export const standardAPI = {
  getStandards(params) {
    return request({
      url: '/standards',
      method: 'get',
      params
    })
  },
  getStandardDetail(id) {
    return request({
      url: `/standards/detail/${id}`,
      method: 'get'
    })
  },
  getProductStandardFiles(params) {
    return request({
      url: '/standards/product-files',
      method: 'get',
      params
    })
  },
  getRelatedStandards(id, limit = 6) {
    return request({
      url: `/standards/${id}/related`,
      method: 'get',
      params: { limit }
    })
  },
  // 获取我的标准
  getMyStandards() {
    return request({
      url: '/standards/my',
      method: 'get'
    })
  },
  // 发布标准
  publishStandard(data) {
    return request({
      url: '/standards/my/publish',
      method: 'post',
      data
    })
  },
  // 获取我的标准详情
  getMyStandardDetail(id) {
    return request({
      url: `/standards/my/${id}`,
      method: 'get'
    })
  },
  // 获取标准编辑状态
  getStandardEditStatus(id) {
    return request({
      url: `/standards/my/${id}/edit-status`,
      method: 'get'
    })
  },
  // 更新标准
  updateStandard(id, data) {
    return request({
      url: `/standards/my/${id}`,
      method: 'put',
      data
    })
  },
  // 删除标准
  deleteStandard(id) {
    return request({
      url: `/standards/my/${id}`,
      method: 'delete'
    })
  }
} 

export const scenarioAPI = {
  getScenarios(params) {
    return request({
      url: '/scenarios',
      method: 'get',
      params
    })
  },
  getScenarioDetail(id) {
    return request({
      url: `/scenarios/${id}`,
      method: 'get'
    })
  },
  submitScenario(data) {
    return request({
      url: '/scenarios/submit',
      method: 'post',
      data
    })
  },
  // 获取我的场景
  getMyScenarios() {
    return request({
      url: '/scenarios/my',
      method: 'get'
    })
  },
  // 发布场景
  publishScenario(data) {
    return request({
      url: '/scenarios/my/publish',
      method: 'post',
      data
    })
  },
  // 获取我的场景详情
  getMyScenarioDetail(id) {
    return request({
      url: `/scenarios/my/${id}`,
      method: 'get'
    })
  },
  // 获取场景编辑状态
  getScenarioEditStatus(id) {
    return request({
      url: `/scenarios/my/${id}/edit-status`,
      method: 'get'
    })
  },
  // 更新场景
  updateScenario(id, data) {
    return request({
      url: `/scenarios/my/${id}`,
      method: 'put',
      data
    })
  },
  // 删除场景
  deleteScenario(id) {
    return request({
      url: `/scenarios/my/${id}`,
      method: 'delete'
    })
  }
} 

export const hazardAPI = {
  getHazards(params) {
    return request({
      url: '/hazards',
      method: 'get',
      params
    })
  },
  getHazardDetail(id) {
    return request({
      url: `/hazards/${id}`,
      method: 'get'
    })
  },
  // 获取隐患分类树
  getHazardCategories() {
    return request({
      url: '/hazards/categories',
      method: 'get'
    })
  },
  // 获取指定父分类下的分类数据
  getHazardCategoryByParent(parentId = null) {
    return request({
      url: '/hazards/categories',
      method: 'get',
      params: { parent_id: parentId }
    })
  }
}

// 百度网盘文档API
export const baiduPanAPI = {
  // 获取指定分类下的百度网盘文档
  // documentType: hazard/education/plan
  getDocumentsByCategory(documentType, categoryId) {
    return request({
      url: `/baidu-pan/categories/${documentType}/${categoryId}/documents`,
      method: 'get'
    })
  },
  // 获取百度网盘文档详情（包含下载链接）
  getDocumentDetail(documentId) {
    return request({
      url: `/baidu-pan/documents/${documentId}`,
      method: 'get'
    })
  },
  // 搜索百度网盘文档
  // documentType: hazard/education/plan
  searchDocuments(documentType, params) {
    return request({
      url: '/baidu-pan/documents',
      method: 'get',
      params: { document_type: documentType, ...params }
    })
  }
} 

export const planAPI = {
  getPlans(params) {
    return request({
      url: '/plans',
      method: 'get',
      params
    })
  },
  getPlanDetail(id) {
    return request({
      url: `/plans/${id}`,
      method: 'get'
    })
  },
  // 获取预案分类树
  getPlanCategories() {
    return request({
      url: '/plans/categories',
      method: 'get'
    })
  },
  // 获取指定父分类下的分类数据
  getPlanCategoryByParent(parentId = null) {
    return request({
      url: '/plans/categories',
      method: 'get',
      params: { parent_id: parentId }
    })
  },
  // 批量获取分类的预案数量（包括所有子分类下的预案）
  getCategoryPlanCounts(categoryIds) {
    return request({
      url: '/plans/categories/plan-counts',
      method: 'get',
      params: { category_ids: categoryIds.join(',') }
    })
  },
  // 申请下载预案
  requestDownload(data) {
    return request({
      url: '/plans/download-request',
      method: 'post',
      data
    })
  }
} 

export const educationAPI = {
  getEducation(params) {
    return request({
      url: '/education',
      method: 'get',
      params
    })
  },
  getEducationDetail(id) {
    return request({
      url: `/education/${id}`,
      method: 'get'
    })
  },
  // 获取宣教资料分类树
  getEducationCategories() {
    return request({
      url: '/education/categories',
      method: 'get'
    })
  },
  // 获取指定父分类下的分类数据
  getEducationCategoryByParent(parentId = null) {
    return request({
      url: '/education/categories',
      method: 'get',
      params: { parent_id: parentId }
    })
  },
  
  // 批量获取分类的子分类数量
  getEducationCategoryCounts(categoryIds) {
    return request({
      url: '/education/categories',
      method: 'get',
      params: { category_ids: categoryIds.join(',') }
    })
  },
  
  // 批量获取分类的文件数量（包括所有子分类下的文件）
  getEducationCategoryFileCounts(categoryIds) {
    return request({
      url: '/education/categories/file-counts',
      method: 'get',
      params: { category_ids: categoryIds.join(',') }
    })
  },
  // 申请下载宣教资料
  requestDownload(data) {
    return request({
      url: '/education/download-request',
      method: 'post',
      data
    })
  }
} 

export const dynamicsAPI = {
  getDynamics(params) {
    return request({
      url: '/dynamics',
      method: 'get',
      params
    })
  },
  getDynamicsDetail(id) {
    return request({
      url: `/dynamics/${id}`,
      method: 'get'
    })
  }
}

// 法律声明相关API
export const declarationAPI = {
  // 按编码获取已发布声明
  getByCode(code) {
    return request({
      url: `/declarations/by-code/${code}`,
      method: 'get'
    })
  }
}

// 领导关怀相关API
export const leadershipCareAPI = {
  // 获取领导关怀列表
  getLeadershipCare(params) {
    return request({
      url: '/leadership-care',
      method: 'get',
      params: {
        ...params,
        _: Date.now() // 添加时间戳避免缓存
      }
    })
  },
  // 创建领导关怀
  createLeadershipCare(data) {
    return request({
      url: '/leadership-care',
      method: 'post',
      data
    })
  },
  // 更新领导关怀
  updateLeadershipCare(id, data) {
    return request({
      url: `/leadership-care/${id}`,
      method: 'put',
      data
    })
  },
  // 删除领导关怀
  deleteLeadershipCare(id) {
    return request({
      url: `/leadership-care/${id}`,
      method: 'delete'
    })
  },
  // 获取领导关怀详情
  getLeadershipCareDetail(id) {
    return request({
      url: `/leadership-care/${id}`,
      method: 'get'
    })
  },
  // 上传文件
  uploadFile(formData) {
    return request({
      url: '/upload/file',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // 点赞领导关怀
  likeLeadershipCare(id) {
    return request({
      url: `/leadership-care/${id}/like`,
      method: 'post'
    })
  },
  // 取消点赞领导关怀
  unlikeLeadershipCare(id) {
    return request({
      url: `/leadership-care/${id}/like`,
      method: 'delete'
    })
  },
  // 检查点赞状态
  checkLikeStatus(id) {
    return request({
      url: `/leadership-care/${id}/like/status`,
      method: 'get'
    })
  }
}

// 专家分类相关API
export const expertCategoriesAPI = {
  // 获取专家分类列表
  getExpertCategories(params = {}) {
    return request({
      url: '/expert-categories/',
      method: 'get',
      params
    })
  },
  // 获取各三级分类下的专家数量（用于首页标签：无专家白底，有专家有色）
  getExpertCategoryCounts(params = { level: 3 }) {
    return request({
      url: '/expert-categories/expert-counts',
      method: 'get',
      params
    })
  }
}

// 收藏相关API
export const favoritesAPI = {
  // 添加收藏
  addFavorite(data) {
    return request({
      url: '/favorites/',
      method: 'post',
      data
    })
  },

  // 取消收藏
  removeFavorite(favoriteId) {
    return request({
      url: `/favorites/${favoriteId}`,
      method: 'delete'
    })
  },

  // 通过内容取消收藏
  removeFavoriteByItem(itemType, itemId) {
    return request({
      url: '/favorites/',
      method: 'delete',
      params: {
        item_type: itemType,
        item_id: itemId
      }
    })
  },

  // 获取收藏列表
  getFavorites(params) {
    return request({
      url: '/favorites/',
      method: 'get',
      params
    })
  },

  // 检查收藏状态
  checkFavoriteStatus(itemType, itemId) {
    return request({
      url: '/favorites/status',
      method: 'get',
      params: {
        item_type: itemType,
        item_id: itemId
      }
    })
  },

  // 获取收藏统计
  getFavoriteStats() {
    return request({
      url: '/favorites/stats',
      method: 'get'
    })
  }
}

// 报错反馈相关API
export const errorReportsAPI = {
  createErrorReport(data) {
    return request({
      url: '/error-reports/submit',
      method: 'post',
      data
    })
  }
}

// 全局搜索API
export const globalSearchAPI = {
  globalSearch(params) {
    return request({
      url: '/global-search',
      method: 'get',
      params
    })
  }
}

// 用户行为追踪API
export const userBehaviorAPI = {
  // 记录转发行为
  recordShareBehavior(data) {
    return request({
      url: '/user-behavior/share-behavior',
      method: 'post',
      data: {
        ...data,
        source: 'pc'
      }
    })
  },
  
  // 记录页面行为
  recordPageBehavior(data) {
    return request({
      url: '/user-behavior/page-behavior',
      method: 'post',
      data
    })
  }
}

// SV按钮点击记录API
export const svClickAPI = {
  // 记录SV按钮点击
  recordSvClick(data) {
    return request({
      url: '/sv-click',
      method: 'post',
      data: {
        ...data,
        platform: 'pc'
      }
    })
  },
  
  // 获取SV按钮点击统计
  getSvClickStats() {
    return request({
      url: '/sv-click/stats',
      method: 'get'
    })
  },
  
  // 获取SV按钮点击记录
  getSvClickRecords(params = {}) {
    return request({
      url: '/sv-click/records',
      method: 'get',
      params
    })
  },

  // 获取服务弹窗配置
  getSvModalConfig() {
    return request({
      url: '/sv-click/modal-config',
      method: 'get'
    })
  }
} 